import { render } from "./FeaturedTopSpotTyre.vue?vue&type=template&id=34000560&scoped=true"
import script from "./FeaturedTopSpotTyre.vue?vue&type=script&lang=js"
export * from "./FeaturedTopSpotTyre.vue?vue&type=script&lang=js"

import "./FeaturedTopSpotTyre.vue?vue&type=style&index=0&id=34000560&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34000560"]])

export default __exports__